import { render, staticRenderFns } from "./AllResult.vue?vue&type=template&id=dc062f60&scoped=true&"
import script from "./AllResult.vue?vue&type=script&lang=js&"
export * from "./AllResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc062f60",
  null
  
)

export default component.exports